<template>
  <div class="mt-4">
    <p>Email Address:</p>
    <p>{{ payload.content }}</p>
    <button class="button is-info is-outlined mt-5" @click="createCompany">Create new resource</button>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FeedContentNewCompanyLead',
  props: {
    payload: {
      type: Object
    }
  },
  methods: {
    ...mapMutations('modals', ['create']),
    createCompany () {
      this.create({
        designator: 'create-company-step-one',
        component_name: 'CreateCompanyStepOne',
        ignore_escape_button: true,
        modal_title: 'Create new Company'
      })
    }
  }
}
</script>
